export default "__VITE_ASSET__BPjCxP8B__"